import { COLORS } from './constants';
import { getCircleBackground } from './icon';
export default _type => [getCircleBackground(COLORS.neutral)];
//# sourceMappingURL=defaultProductIcon.js.map